<template>
  <div class="" v-bind:style="'top:0px;position:relative;width:' + width + ';height:' + height">
    <div style="position:absolute;width:100%;height:100%;top:0px;z-index:1">
      <table border="0" style="height:100%;width:100%">
        <tr>
          <td valign="middle" align="center" class="custom-medium-text">
            <slot scope="testScope" :chartOptions="chartOptions" :datacollection="datacollection">
              {{text}}
            </slot>
          </td>
        </tr>
      </table>
    </div>
    <dougnut-chart :options="chartOptions" :chart-data="datacollection" ref="chart" v-bind:style="'position:relative;z-index:2;width:' + width + ';height:' + height"></dougnut-chart>
  </div>
</template>

<script>
  import DougnutChart from "./Doughnut.js";

  export default {
    name: "simple-dougnut-chart",
    components: {
      DougnutChart,
    },
    props: {
      text: {
        required: false,
        type: String,
        default: "text"
      },
      width: {
        required: false,
          type: String,
          default: "100%"
      },
      height: {
        required: false,
        type: String,
        default: "100%"
      }
    },
    data() {
      return {
        chartOptions: {
          hoverBorderWidth: 20,
          legend: {
            display: false,
          },
        },
        datacollection: null,
        
      };
    },
    mounted() {
      this.setData(["olle", "bertil", "oskar"], [33.33, 33.33, 33.33]);
      this.setData(["anna", "jenny"], [60, 40]);
      this.setData(["olle", "bertil", "oskar"], [33.33, 33.33, 33.33]);
    },
    methods: {
      
      setData(labels, data) {

        var collection = {
          hoverBackgroundColor: "red",
          hoverBorderWidth: 10,
          labels: ["Green", "Red", "Blue"],
          datasets: [
            {
              label: "Data One",
              backgroundColor: ["#92D050", "#12AEF5", "#EFA919", "#8B9EB5", "#5A81A6", "#B6E874"],
              data: [],
            }]
        }
        collection.labels = labels;
        collection.datasets[0].data = data;
        this.datacollection = collection;
      },
    },

  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/charts/simple-doughnut-chart.vue